import { ServiceType } from '@caterdesk/types--graphql'
import sortBy from 'lodash/sortBy'
import { InRangeLocations } from '../../hooks/useAddressInRangeCheck'

export const getClosestVendorData = (data: InRangeLocations) => {
  const closestLocation = data?.[0]
  if (!closestLocation) {
    return {
      deliveryFeeExTax: 0,
      minOrderValueExTax: null,
      minNoticePeriod: null,
    }
  }

  const sortedRegions = sortBy(closestLocation.deliveryRegions, (r) => r.orderPosition)
  const gmRegion = sortedRegions.find((r) => r.serviceType === ServiceType.Gm)

  const deliveryFeeExTax = gmRegion?.deliveryFee?.totalExTax ?? 0
  if (gmRegion && gmRegion.deliveryFee?.totalExTax === undefined) {
    console.error('Delivery fee not found')
  }

  const minOrderValueExTax =
    gmRegion?.minOrderValueExTax ??
    (gmRegion?.minOrderValueExTax ? gmRegion.minOrderValueExTax * 100 : null)
  if (gmRegion && minOrderValueExTax === null) {
    console.error(`Minimum order value for region ${gmRegion.id} not found`)
  }

  const vendorDetails = closestLocation.details
  const minNoticePeriod = vendorDetails?.effectiveMinimumNoticePeriod ?? null
  if (closestLocation && vendorDetails?.effectiveMinimumNoticePeriod === undefined) {
    console.error('Minimum notice period not found')
  }

  return {
    deliveryFeeExTax,
    minOrderValueExTax,
    minNoticePeriod,
  }
}
